export default __webpack_public_path__ + "static/media/Florence-bef.79a71d6e.png";